import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from '../button/button';
import { ModalContext } from '../services/contexts/modalcontext/modal.context';
import './blockchain.scss';

export default function Blockchain() {

    window.scrollTo(0, 0)

    const { contextModal, setContextModal } = useContext(ModalContext);

    return (
        <div className="blockchain">
            <div className="row blockchain_top">
                <Link to="/" className="blockchain_body_back">
                    &#8592;
                </Link>

                <Link to="/" className="blockchain_body_back">
                    Новичкам
                </Link>
            </div>
            <div className="blockchain_body">
                <div className="row">
                    <div className="blockchain_body_left">
                        <Link to="/" className="blockchain_body_back">
                            &#8592;
                        </Link>
                    </div>

                    <h1>
                        Как блокчейн может устранить неэффективность традиционного процесса от закупки до оплаты.
                    </h1>
                </div>
                <div className="row">
                    <div className="blockchain_body_left"></div>
                    <div>
                        <p>
                            Есть одна особенность в улучшении процесса P2P (закупка до оплаты). Учитывая сложный набор инструментов, доступных сегодня, общение между заинтересованными сторонами (поставщиками, субпоставщиками и банками) должно быть простым. Удивительно, но это не так!
                        </p>
                        <h3>
                            Обычный P2P неэффективен
                        </h3>
                        <p>
                            Как правило, любые попытки импровизировать процесс P2P хлопотны и отнимают много времени. В большинстве случаев проблемы возникают из-за того, что покупатель и продавец действуют в разных экосистемах. Каждый из них работает над своей собственной ERP-системой, таким образом, сталкиваясь с разными источниками одной и той же истины. Поскольку передача данных осуществляется не в режиме реального времени, информация между заинтересованными сторонами и их системами непоследовательна, что приводит к неэффективной трате ресурсов и более высоким затратам.
                        </p>
                        <h3>
                            Понять функционирование бизнес-блокчейна
                        </h3>
                        <p>
                            Блокчейн B2P для закупок с оплатой работает по двум направлениям: оптимизирует финансовые функции и обеспечивает прозрачную коммуникацию. Блокчейн проверяет данные и выравнивает их по объектам. Распределенная база данных обеспечивает единый источник истины между покупателем, продавцом и другими заинтересованными сторонами, позволяя им преодолевать проблемы связи. Такая платформа вместе с закрытой записью транзакции служит единственным единообразным источником того, что хотят знать заинтересованные стороны.
                        </p>
                        <h3>
                            Блокчейн-решение B2P по сравнению с традиционной настройкой
                        </h3>
                        <p>
                            Традиционная корпоративная структура часто распределяет несогласованную информацию по компаниям. Пропущенные обновления основных данных и ручной ввод информации из электронных писем приводят к несогласованности между базами данных двух предприятий.
                        </p>
                        <p>
                            Однако бизнес-блокчейны - это распределенные базы данных, доступные всем разрешенным участникам в любой момент времени. После того, как данные записаны в блокчейн, никакие изменения не могут быть сделаны. Блокчейны только добавляют данные. Любое изменение протокола требует согласия всех участников. Формат блокчейна таков, что он выводит полную и проверенную запись транзакций в хронологическом порядке.
                        </p>
                        <h3>
                            Роль смарт-контрактов
                        </h3>
                        <p>
                            Смарт-контракт, неотъемлемая часть бизнес-блокчейнов, автоматически выполняет определенные действия при выполнении заранее определенных условий. Человеческая роль либо устранена, либо сведена к минимуму. Даже счета-фактуры генерируются смарт-контрактом, в зависимости от введенных данных.
                        </p>
                        <p>
                            Например, если соглашение предусматривает оплату через 30 дней, смарт-контракт выполнит платеж через 30 дней.
                        </p>
                        <h3>
                            Точность в обнаружении аномалий
                        </h3>
                        <p>
                            Внедрение блокчейна в закупки может эффективно проверять и обнаруживать аномалии между заказом на покупку и подтверждением продажи до или после доставки товаров. В процессе P2P это известная проблема, вызывающая трение. В зависимости от времени обнаружения ошибки несоосность может привести к увеличению стоимости или задержке производства в случае доставки неправильных товаров.
                        </p>
                        <p>
                            Когда бизнес-блокчейн согласовывает детали заказа (место, количество, время доставки и т. Д.), На основе согласованных данных создается автоматическое подтверждение, что исключает любую вероятность несоответствия.
                        </p>
                        <h3>
                            Интеграция с ERP
                        </h3>
                        <p>
                            Блокчейн B2P для обеспечения оплаты может быть легко интегрирован в систему ERP. Смарт-контракты выполняют передачу данных в систему ERP. Когда покупатель и продавец договариваются об условиях, смарт-контракт запускается. Все заинтересованные стороны могут получить точные обновленные основные данные в своих системах. Они могут использовать эти основные данные для обоснования своих заказов и цен. Эта процедура устраняет ошибки, возникающие из-за плохо загруженных основных данных. Внедрение блокчейна оптимизирует процесс согласования.
                        </p>
                        <h3>
                            Подводя итоги
                        </h3>
                        <p>
                            Когда дело касается закупок до оплаты, коммуникация между различными заинтересованными сторонами всегда затруднена. Однако бизнес-блокчейн упрощает общение, обеспечивает прозрачность и автоматизирует систему. Это помогает обнаружить аномалии между заказом на покупку и подтверждением продажи, тем самым устраняя проблему.
                        </p>
                        <p>
                            Наша компания предоставляет решение на основе технологии закупок до оплаты, основанное на блокчейне, которое охватывает весь спектр процессов P2P - от сканирования и обработки счетов, управления данными, управления средствами до обеспечения своевременной оплаты при минимальной утечке стоимости и снижении затрат. операций.
                        </p>
                        <p>
                            Свяжитесь с нашими профильными экспертами, чтобы поделиться своими потребностями в решении блокчейн B2P для закупок за оплату.
                        </p>

                        <div className="row">
                            <Button txt='записаться на обучение' style='primary' handlerClick={() => setContextModal({show: true, status:2})} />
                            <Button txt='бесплатная консультация' style='primary' handlerClick={() => setContextModal({show: true, status:1})} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}